import React from 'react';

function SimpleSignleParentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={49}
      height={48}
      viewBox="0 0 49 48"
      fill="none">
      <path
        opacity="0.4"
        d="M48.9845 47.1277C48.9845 47.6094 38.0192 47.9995 24.4922 47.9995C10.9653 47.9995 0 47.6094 0 47.1277C0 46.646 10.9653 46.2559 24.4922 46.2559C38.0192 46.2559 48.9845 46.646 48.9845 47.1277Z"
        fill="#BCB297"
      />
      <path
        d="M31.6392 20.469C31.6392 16.6458 30.1119 14.4818 26.5873 13.8948V12.6934H22.8264V13.8948C19.2992 14.4818 17.7819 16.6434 17.7819 20.469L15.5283 31.0952L18.0331 31.717L20.4534 20.0063C20.4534 17.0388 21.6274 17.3224 24.5029 17.3398L24.4979 17.3771C27.5052 17.3722 28.9876 16.9767 28.9876 20.0063L31.4104 31.717L33.9003 31.0952L31.6417 20.469H31.6392Z"
        fill="#FFC99C"
      />
      <path
        d="M24.94 45.8107L27.1264 45.6615L28.1587 31.2793L24.751 31.3564C24.9923 35.6497 24.9574 44.4003 24.94 45.8107Z"
        fill="#FFC99C"
      />
      <path
        d="M24.1922 45.6614C24.1748 44.2511 24.0977 35.6497 24.3389 31.3564L20.9287 31.2793L21.961 45.6614H24.1922Z"
        fill="#FFC99C"
      />
      <path
        d="M31.0516 6.89129C31.0516 10.498 27.7558 13.4232 24.6913 13.4232C21.6269 13.4232 18.3311 10.498 18.3311 6.89129C18.3311 3.28456 21.1791 0.359375 24.6913 0.359375C28.2035 0.359375 31.0516 3.28456 31.0516 6.89129Z"
        fill="#FFC99C"
      />
      <path
        d="M17.4057 32.2922C17.259 32.8792 16.662 33.2374 16.075 33.0882C15.4879 32.9414 15.1297 32.3444 15.279 31.7574L15.6347 30.3396C15.7814 29.7526 16.3784 29.3944 16.9654 29.5436C17.5525 29.6904 17.9107 30.2874 17.7614 30.8744L17.4057 32.2922Z"
        fill="#FFC99C"
      />
      <path
        d="M32.0214 32.2922C32.1682 32.8792 32.7651 33.2374 33.3522 33.0882C33.9392 32.9414 34.2974 32.3444 34.1481 31.7574L33.7924 30.3396C33.6457 29.7526 33.0487 29.3944 32.4617 29.5436C31.8746 29.6904 31.5165 30.2874 31.6657 30.8744L32.0214 32.2922Z"
        fill="#FFC99C"
      />
      <path
        d="M28.9944 21.8882L32.0663 21.816C32.0663 21.816 31.8026 19.3834 31.3425 17.5054C30.6634 14.7419 27.7009 14.125 27.7009 14.125C27.7009 14.125 27.2084 16.7069 24.7135 16.7542C22.2187 16.7069 21.7262 14.125 21.7262 14.125C21.7262 14.125 18.7637 14.7419 18.0871 17.5054C17.6269 19.3809 17.3633 21.8111 17.3633 21.8111L20.4352 21.8882L20.4427 25.8805C18.5149 29.5145 17.4653 34.4122 17.4653 34.4122C17.4653 34.4122 17.6767 35.9246 24.7359 35.9246C31.7952 35.9246 32.0066 34.4122 32.0066 34.4122C32.0066 34.4122 30.942 29.4474 28.9894 25.8058L28.9969 21.8882H28.9944Z"
        fill="#17385D"
      />
      <path
        d="M24.2354 45.6055V47.0158H20.2382C19.681 47.0158 20.0839 46.6253 20.6809 46.3393C21.7928 45.8069 21.957 45.6627 21.957 45.6627L24.2329 45.6055H24.2354Z"
        fill="#8C7257"
      />
      <path
        d="M24.9404 45.6055V47.0158H28.9949C29.5521 47.0158 29.1491 46.6253 28.5521 46.3393C27.4403 45.8069 27.2463 45.6627 27.2463 45.6627L24.9404 45.6055Z"
        fill="#8C7257"
      />
      <path
        d="M30.034 2.26851C28.7008 0.549716 26.8626 0 24.8627 0H24.5493C22.5494 0 20.7884 0.360674 19.378 2.26851C17.4304 4.90018 17.8109 10.3352 18.9079 11.5888C20.0048 12.8425 20.9276 12.9121 20.9276 12.9121C18.7139 9.05414 20.4625 5.05689 20.4625 5.05689C20.4625 5.05689 22.6713 5.17379 24.7085 5.17379C26.7457 5.17379 28.3326 5.20613 28.9545 5.05689C28.9545 5.05689 30.6186 8.45965 28.4894 12.9121C28.4894 12.9121 29.4122 12.8425 30.5066 11.5888C31.6011 10.3352 32.0414 4.85541 30.0365 2.26851H30.034Z"
        fill="#AF6617"
      />
      <path
        d="M45.6364 13.8772C45.6364 17.1208 42.6714 19.7524 39.9154 19.7524C37.1593 19.7524 34.1943 17.1233 34.1943 13.8772C34.1943 10.6311 36.7564 8.00195 39.9154 8.00195C43.0744 8.00195 45.6364 10.6311 45.6364 13.8772Z"
        fill="#FFC99C"
      />
      <path
        d="M41.1596 19.043H38.3389V20.6896H41.1596V19.043Z"
        fill="#FFC99C"
      />
      <path
        d="M39.9077 20.2154H39.858C36.0522 20.2154 34.2961 22.2078 33.9429 25.9613L32.846 34.3811L32.6992 35.3537V35.7666C32.6992 36.279 33.1271 36.6944 33.6395 36.6944C34.1519 36.6944 34.5797 36.279 34.5797 35.7666V35.0229H35.102L35.709 30.0133L35.9652 25.6031C35.9652 23.046 37.3158 22.959 39.8704 22.959L39.9027 23.0809C42.4598 23.0809 43.808 22.949 43.808 25.5061L44.6711 35.0229H44.9248V35.7666C44.9248 36.279 45.3526 36.6944 45.865 36.6944C46.3774 36.6944 46.8053 36.279 46.8053 35.7666V35.3537L46.8252 34.6871L45.5292 25.9812C45.5292 22.1755 43.7159 20.2129 39.9102 20.2129L39.9077 20.2154Z"
        fill="#FFC99C"
      />
      <path
        d="M36.3604 30.7949L36.8752 45.8064L38.4398 45.7989L39.8328 34.2872L41.263 45.8387H42.7928L43.4146 30.7949H36.3604Z"
        fill="#17385D"
      />
      <path
        d="M39.908 22.3955C39.908 22.3955 38.3857 20.3583 38.3434 20.3658C36.0177 20.7364 34.5924 22.1144 34.1571 24.378C34.0626 24.8655 32.8438 34.0838 32.8438 34.0838H35.2665L36.2813 26.4375L36.3112 32.6013L43.4077 32.7108L43.5868 26.6141L44.5718 34.0838H46.9075C46.9075 34.0838 45.629 24.3307 45.4151 23.6616C44.8479 21.8682 43.5271 20.6817 41.5148 20.3359L39.9055 22.3955H39.908Z"
        fill="#89C3F1"
      />
      <path
        d="M38.4696 45.7441L38.5318 47.0152H34.8803C34.3903 47.0152 34.7435 46.6321 35.2683 46.3809C36.2459 45.9133 36.9299 45.7665 36.9299 45.7665L38.4671 45.7441H38.4696Z"
        fill="#433934"
      />
      <path
        d="M41.2585 45.8409L41.1689 47.015H44.9747C45.4846 47.015 45.1164 46.6966 44.5692 46.4354C43.5519 45.9504 42.7609 45.8359 42.7609 45.8359L41.256 45.8409H41.2585Z"
        fill="#433934"
      />
      <path
        d="M34.3787 15.271C34.3787 15.271 35.5578 11.6966 36.3612 10.7564C36.3612 10.7564 39.8361 14.2835 41.6146 14.8108L41.7464 14.1268C41.7464 14.1268 42.5697 15.2212 43.6269 15.3406L43.9801 14.7536L45.1566 16.3406C45.1566 16.3406 46.8033 14.4601 45.5098 11.4628C44.2164 8.46546 40.045 6.29147 36.6945 8.58237L36.0478 8.11225L35.9881 8.99279C35.9881 8.99279 32.8863 11.7936 34.3787 15.271Z"
        fill="#AF6617"
      />
      <path
        d="M14.2649 27.0232C14.2649 24.2124 12.9516 22.6205 10.601 22.1902V21.3867H7.54395V22.1902C5.19335 22.6205 3.92726 24.2124 3.92726 27.0232L2.31543 34.8361L4.18098 35.2938L5.96942 26.6849C5.96942 24.5034 6.83752 24.7124 8.95182 24.7248V24.7522C11.0686 24.7497 12.2551 24.4587 12.2551 26.6849L14.0385 35.2938L15.8966 34.8361L14.2624 27.0232H14.2649Z"
        fill="#FFC99C"
      />
      <path
        d="M9.29022 45.6541L10.8971 45.5446L11.6557 34.9707L9.14844 35.0279C9.32504 38.1844 9.30017 44.6168 9.28773 45.6541H9.29022Z"
        fill="#FFC99C"
      />
      <path
        d="M8.73823 45.5446C8.7258 44.5074 8.66859 38.1819 8.84519 35.0279L6.33789 34.9707L7.09655 45.5446H8.73574H8.73823Z"
        fill="#FFC99C"
      />
      <path
        d="M14.6729 16.3597C14.6729 19.5187 11.785 22.0832 9.10108 22.0832C6.41717 22.0832 3.5293 19.5212 3.5293 16.3597C3.5293 13.1982 6.02416 10.6387 9.10108 10.6387C12.178 10.6387 14.6729 13.2007 14.6729 16.3597Z"
        fill="#FFC99C"
      />
      <path
        d="M3.74868 35.7122C3.63923 36.145 3.20145 36.4062 2.76864 36.2992C2.33583 36.1898 2.07466 35.752 2.1841 35.3192L2.44528 34.277C2.55472 33.8442 2.99251 33.583 3.42531 33.69C3.85812 33.7994 4.1193 34.2372 4.01234 34.67L3.75116 35.7122H3.74868Z"
        fill="#FFC99C"
      />
      <path
        d="M14.497 35.7122C14.6065 36.145 15.0443 36.4062 15.4771 36.2992C15.9099 36.1898 16.1711 35.752 16.0641 35.3192L15.8029 34.277C15.6935 33.8442 15.2557 33.583 14.8229 33.69C14.3901 33.7994 14.1289 34.2372 14.2359 34.67L14.497 35.7122Z"
        fill="#FFC99C"
      />
      <path
        d="M12.2704 28.0655L14.529 28.0132C14.529 28.0132 14.335 26.2248 13.9967 24.8443C13.4967 22.8121 11.3202 22.3594 11.3202 22.3594C11.3202 22.3594 10.9596 24.2573 9.12387 24.2921C7.28817 24.2573 6.9275 22.3594 6.9275 22.3594C6.9275 22.3594 4.75102 22.8121 4.25105 24.8443C3.91277 26.2248 3.71875 28.0083 3.71875 28.0083L5.97731 28.0655L5.98228 31.0006C4.56447 33.6721 3.79337 37.2738 3.79337 37.2738C3.79337 37.2738 3.94759 38.3857 9.1388 38.3857C14.33 38.3857 14.4842 37.2738 14.4842 37.2738C14.4842 37.2738 13.7007 33.6248 12.2655 30.9459L12.2704 28.0655Z"
        fill="#CD232E"
      />
      <path
        d="M8.72383 45.502V46.5392H5.83347C5.42305 46.5392 5.71905 46.2507 6.15932 46.0417C6.97767 45.6512 7.07468 45.5442 7.07468 45.5442L8.72383 45.502Z"
        fill="#AF6617"
      />
      <path
        d="M9.19434 45.502V46.5392H12.0374C12.4479 46.5392 12.1519 46.2507 11.7116 46.0417C10.8932 45.6512 10.8833 45.5393 10.8833 45.5393L9.19434 45.502Z"
        fill="#AF6617"
      />
      <path
        d="M10.35 13.2716L5.07924 14.9232C5.07924 14.9232 4.84294 18.8011 5.6389 21.9128C5.6389 21.9128 1.9078 19.7986 3.61167 14.5103C4.79319 10.8464 8.89989 9.74945 11.4271 10.8663C11.4271 10.8663 12.6608 10.8066 13.8946 12.2767C15.1283 13.7467 16.5088 18.5648 12.8947 21.9725C12.8947 21.9725 13.9518 19.0921 13.6583 15.3312C13.6583 15.3312 12.7031 15.0103 10.35 13.2691V13.2716Z"
        fill="#AF6617"
      />
    </svg>
  );
}

export default SimpleSignleParentIcon;
